import React, { useState, useEffect } from "react";
import { SnackbarProvider, useSnackbar } from "notistack";
import { useParams, useNavigate } from "react-router-dom";
import { ShoppingBasket } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { addProduct, setProduct } from "./state";
import { AlgeriaCities } from "./AlgeriaCities";
import { Modal, Box, Typography, Button } from "@mui/material";
function Page() {
  const fraisLivraison = {
  "Alger": { domicile: 400, stopDesk: 250 },
  "Boumerdes": { domicile: 600, stopDesk: 300 },
  "Blida": { domicile: 600, stopDesk: 300 },
  "Tipaza": { domicile: 600, stopDesk: 300 },
  "Tizi Ouzou": { domicile: 700, stopDesk: 350 },
  "Médéa": { domicile: 700, stopDesk: 350 },
  "Bouira": { domicile: 700, stopDesk: 350 },
  "Béjaïa": { domicile: 800, stopDesk: 350 },
  "Skikda": { domicile: 800, stopDesk: 350 },
  "Sidi bel Abbas": { domicile: 800, stopDesk: 350 },
  "Sétif": { domicile: 800, stopDesk: 350 },
  "Relizane": { domicile: 800, stopDesk: 350 },
  "Oum El Bouaghi": { domicile: 800, stopDesk: 350 },
  "Oran": { domicile: 800, stopDesk: 350 },
  "M'Sila": { domicile: 800, stopDesk: 350 },
  "Mostaganem": { domicile: 800, stopDesk: 350 },
  "Mila": { domicile: 800, stopDesk: 350 },
  "Mascara": { domicile: 800, stopDesk: 350 },
  "Tissemsilt": { domicile: 800, stopDesk: 350 },
  "Tlemcen": { domicile: 800, stopDesk: 350 },
  "Chlef": { domicile: 800, stopDesk: 350 },
  "Constantine": { domicile: 800, stopDesk: 350 },
  "Batna": { domicile: 800, stopDesk: 350 },
  "Annaba": { domicile: 800, stopDesk: 350 },
  "Aïn Témouchent": { domicile: 800, stopDesk: 350 },
  "Ain Defla": { domicile: 800, stopDesk: 350 },
  "Bordj Bou Arreridj": { domicile: 800, stopDesk: 350 },
  "Jijel": { domicile: 850, stopDesk: 350 },
  "Tiaret": { domicile: 900, stopDesk: 350 },
  "Souk Ahras": { domicile: 900, stopDesk: 350 },
  "Tébessa": { domicile: 900, stopDesk: 350 },
  "Khenchela": { domicile: 900, stopDesk: 350 },
  "Guelma": { domicile: 900, stopDesk: 350 },
  "El Taref": { domicile: 900, stopDesk: 350 },
  "Saïda": { domicile: 900, stopDesk: 350 },
  "Biskra": { domicile: 1000, stopDesk: 500 },
  "Ouled Djellal": { domicile: 1000, stopDesk: 550 },
  "Djelfa": { domicile: 1000, stopDesk: 500 },
  "Laghouat": { domicile: 1000, stopDesk: 500 },
  "Ouargla": { domicile: 1100, stopDesk: 500 },
  "El Mghair": { domicile: 1100, stopDesk: 600 },
  "El Oued": { domicile: 1100, stopDesk: 500 },
  "Touggourt": { domicile: 1100, stopDesk: 500 },
  "Ghardaia": { domicile: 1100, stopDesk: 500 },
  "El Meniaa": { domicile: 1150, stopDesk: 550 },
  "El Bayadh": { domicile: 1200, stopDesk: 600 },
  "Naama": { domicile: 1200, stopDesk: 600 },
  "Béchar": { domicile: 1200, stopDesk: 600 },
  "Beni Abbas": { domicile: 1200, stopDesk: 750 },
  "Timimoune": { domicile: 1500, stopDesk: 700 },
  "Tindouf": { domicile: 1500, stopDesk: 700 },
  "Adrar": { domicile: 1500, stopDesk: 700 },
  "In Salah": { domicile: 1700, stopDesk: 900 },
  "Tamanrasset": { domicile: 1800, stopDesk: 1000 },
  "Illizi": { domicile: 2000, stopDesk: 1000 },
};

  
  const [modeLivraison, setModeLivraison] = useState("domicile"); // ou "stopDesk"
  const [prixLivraison, setPrixLivraison] = useState(null);
        const langue = useSelector((state) => state.langue.value);
  
  const [orderInfo, setOrderInfo] = useState({
    nom: "",
    telephone: "",
    wilaya: "",
    commune: "",
  });
  const [product, setProductt] = useState([]);
  const [selectedWeight, setSelectedWeight] = useState(1);
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const products = useSelector((state) => state.panier.value);
  let Total = products.reduce((acc, product) => acc + product.price, 0);
  const navigate = useNavigate();
  
  const sendMessageToTelegram = async (message) => {
    const botToken = import.meta.env.VITE_TELEGRAM_BOT_TOKEN; 
    const chatId = import.meta.env.VITE_TELEGRAM_CHAT_ID;
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
  
    try {
      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          chat_id: chatId,
          text: message,
        }),
      });
      window.fbq('track', 'Purchase', {
  currency: 'DZD',
  value: selectedWeight * product.prix  + prixLivraison,
  contents: [
    {
      id: product._id, // ou un SKU
      quantity: selectedWeight,
      item_price: product.prix,
    },
  ],
  content_type: 'product',
});

    } catch (error) {
      console.error("Erreur d'envoi Telegram :", error);
    }
  };

   const isFormValid = () => {
      return orderInfo.nom.trim() !== "" &&
      orderInfo.telephone.trim() !== "" &&
      orderInfo.wilaya.trim() !== "" &&
      orderInfo.commune.trim() !== "";
    };
  
  
    const [openConfirm, setOpenConfirm] = useState(false);
  
  const handleConfirmOrder = () => {
    if (!isFormValid() ) {
      alert("❌ Veuillez remplir tous les champs et ajouter des produits.");
      return;
    }
    if (
      !(orderInfo.telephone.length === 9 || orderInfo.telephone.length === 10) ||
      !orderInfo.telephone.startsWith("0")
    ) {
      alert("❌ Veuillez entrer un numéro de téléphone valide.");
      return;
    }
    setOpenConfirm(true); // Ouvre le modal de confirmation
  };
  
  const sendOrder = async () => {
    setOpenConfirm(false);
  
    let productList = products
      .map(
        (pro) =>
          `🛍 ${pro.weight >= 1000 ? pro.weight / 1000 + "kg" : pro.weight + "g"} ${pro.name} - ${pro.price} DA`
      )
      .join("\n");
  
    let message = `🚀 Nouvelle commande !\n👤 Client: ${orderInfo.nom}\n📞 Téléphone: ${orderInfo.telephone}\n📍 Adresse: ${orderInfo.commune}, ${orderInfo.wilaya}\n\n🛒 Produits:\n${selectedWeight}  ${product.title } \n💰 Prix de commande: ${selectedWeight * product.prix} \n🚚 Livraison: ${modeLivraison === "domicile" ? "À domicile" : "Point relais"} (${prixLivraison} DA)\n\n💰 Total: ${selectedWeight * product.prix  + prixLivraison} DA\n✅ Statut: Confirmée`;
  
    try {
      await sendMessageToTelegram(message);
      alert("✅ Commande confirmée avec succès !");
    } catch (error) {
      alert("❌ Erreur lors de la confirmation de la commande !");
    }
  };
  

  useEffect(() => {
   
      getProduct();
    
  }, []); // Ajout de `id` dans les dépendances pour s'assurer de la mise à jour

  const getProduct = async () => {
    try {
      const response = await fetch(`https://antar-5byu.onrender.com/getpost/${id}`);
      if (!response.ok) throw new Error("Erreur lors de la récupération des données.");
      const result = await response.json();
      setProductt(result);
    } catch (error) {
      console.error("Erreur produit:", error);
      enqueueSnackbar("Erreur: " + error.message, { variant: "error" });
    }
  };

const AjoutPanier = () => {
  if (!product) return;

  const prixTotal = (product.prix * selectedWeight) ;

  const existingProduct = products.find((item) => item.id === id);

  if (existingProduct) {
    const updatedCart = products.map((item) =>
      item.id === id
        ? {
            ...item,
            weight: item.weight + selectedWeight,
            price: item.price + prixTotal,
            quantity: item.quantity + 1,
          }
        : item
    );

    dispatch(setProduct(updatedCart)); // ✅ Vérifier que `updatedCart` est bien un tableau
  } else {
    dispatch(
      addProduct({
        id,
        name: product.title,
        price: prixTotal,
        weight: selectedWeight,
        image: product.picturePaths,
        quantity: 1,
      })
    ); // ✅ Vérifier que l'objet envoyé est bien structuré
  }

  enqueueSnackbar(`${selectedWeight}g de ${product.title} ajouté au Panier`, { variant: "success" });
};

  if (!product) {
    return <p className="text-center text-gray-700">Chargement du produit...</p>;
  }

  const prixTotal = selectedWeight ? (product.prix * selectedWeight)  : 0;

  useEffect(() => {
    if (orderInfo.commune && fraisLivraison[orderInfo.wilaya]) {
      const prix = fraisLivraison[orderInfo.wilaya][modeLivraison];
      setPrixLivraison(prix);
    } else {
      setPrixLivraison(null);
    }
  }, [orderInfo.commune, modeLivraison]);

  return (
    <div className="flex flex-col sm:flex-row mx-auto h-auto bg-gray-300 w-full shadow-lg  overflow-hidden">
      {/* Image */}
      <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <Box sx={{ p: 4, bgcolor: "white", borderRadius: 2, mx: "auto", mt: 10, width: 400, textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            🛒 Confirmer la commande ?
          </Typography>
          <Typography variant="body1" sx={{ my: 2 }}>
          Vous êtes sur le point de confirmer votre commande de <b> {selectedWeight} {product.title?.slice(0, -5)} </b>   pour un total de <b>{prixTotal + prixLivraison} DA</b>.
          </Typography>
          <Button onClick={sendOrder} variant="contained" color="success" sx={{ mr: 1 }}>
            Confirmer ✅
          </Button>
          <Button onClick={() => setOpenConfirm(false)} variant="outlined" color="error">
            Annuler ❌
          </Button>
        </Box>
      </Modal>
      <div  className="relative sm:w-full px-1 max-h-[600px]">
        <img src={product.picturePaths} alt={product.title} className="w-full h-72 sm:h-full object-cover rounded-2xl" />
        <div className="absolute top-2 right-2 bg-green-600 text-white text-xs px-3 py-1 rounded-lg shadow-md">
          {product.prix} DA/Kg
        </div>
      </div>

      {/* Contenu */}
      <div dir="rtl" className="p-4 space-y-4 sm:max-w-96 lg:max-w-full ">
        <h1 className="text-3xl font-bold text-gray-800">{product.title}</h1>

        {/* Sélection du poids */}
        <div className="flex justify-between items-center border-b pb-3">
          <select
            className="border border-gray-400 rounded-lg text-gray-700 font-semibold p-2 w-32 focus:ring-2 focus:ring-green-500"
            value={selectedWeight}
            onChange={(e) => setSelectedWeight(Number(e.target.value))}
          >
             <option value="1">1</option>
            <option value="2">2</option>
            <option value="5">5</option>
            <option value="10">10</option>
          </select>
          <p className="text-xl font-bold text-green-600">{prixTotal > 0 ? `${prixTotal} DA` : "0 DA`"}</p>
        </div>

        {/* Description */}
        <p className="text-gray-800 text-sm leading-relaxed whitespace-pre-line">
  {product.description ? (
    <>
      {product.description}
      <br />
      <span className="text-gray-600">
      {langue === "fr"
    ? "Découvrez nos épices de haute qualité à des prix imbattables ! 🌿✨ Sélectionnées avec soin, elles apportent une saveur authentique à vos plats tout en respectant votre budget. Faites le choix du goût et de la fraîcheur pour une cuisine pleine d’arômes ! 🍛🔥"
    : "✨ اكتشف روعة توابلنا المختارة بعناية! 🌿\nنقدم لك نكهات أصيلة وجودة عالية بأسعار تنافسية.\nتم اختيار كل نوع بعناية ليضفي على أطباقك طابعاً فريداً يرضي الذوق ويُراعي الميزانية.\nاختر التميز، واستمتع بمذاق طبيعي ونضارة استثنائية تجعل مطبخك ينبض بالعطر والنكهة! 🍛🔥"
  }
      </span>
    </>
  ) : (
    <span className="text-gray-600">
      {langue === "fr"
        ? "Découvrez nos épices de haute qualité à des prix imbattables ! 🌿✨ Sélectionnées avec soin, elles apportent une saveur authentique à vos plats tout en respectant votre budget. Faites le choix du goût et de la fraîcheur pour une cuisine pleine d’arômes ! 🍛🔥"
        : "✨ اكتشف روعة توابلنا المختارة بعناية! 🌿\nنقدم لك نكهات أصيلة وجودة عالية بأسعار تنافسية.\nتم اختيار كل نوع بعناية ليضفي على أطباقك طابعاً فريداً يرضي الذوق ويُراعي الميزانية.\nاختر التميز، واستمتع بمذاق طبيعي ونضارة استثنائية تجعل مطبخك ينبض بالعطر والنكهة! 🍛🔥"
              }        </span>
  )}
</p>

<div className="mt-6 space-y-3 bg-white p-4 rounded-xl shadow-md">
  <h2 className="text-2xl font-bold text-green-900">
    {langue === "fr" ? "Commander maintenant" : "اطلب الآن"}
  </h2>

  {/* Nom */}
  <input
    type="text"
    placeholder={langue === "fr" ? "Nom complet" : "الاسم الكامل"}
    className="w-full p-2 rounded-md bg-gray-200 text-gray-900"
    value={orderInfo.nom}
    onChange={(e) => setOrderInfo({ ...orderInfo, nom: e.target.value })}
  />

  {/* Téléphone */}
  <input
    type="tel"
    placeholder={langue === "fr" ? "Téléphone" : "رقم الهاتف"}
    className={`w-full p-2 rounded-md bg-gray-200 text-gray-900 ${langue==="ar"? "text-right":null}`}
    value={orderInfo.telephone}
    onChange={(e) => setOrderInfo({ ...orderInfo, telephone: e.target.value })}
  />

  {/* Wilaya */}
  <select
    className="w-full p-2 rounded-md bg-gray-200 text-gray-900"
    value={orderInfo.wilaya}
    onChange={(e) => setOrderInfo({ ...orderInfo, wilaya: e.target.value, commune: "" })}
  >
    <option value="">{langue === "fr" ? "Choisir une wilaya" : "اختر ولاية"}</option>
    {[...new Map(AlgeriaCities.map((c) => [c.wilaya_name_ascii, c])).values()].map((w, i) => (
      <option key={i} value={w.wilaya_name_ascii}>
        {w.wilaya_name_ascii}
      </option>
    ))}
  </select>

  {/* Commune */}
  <select
    className="w-full p-2 rounded-md bg-gray-200 text-gray-900"
    value={orderInfo.commune}
    onChange={(e) => setOrderInfo({ ...orderInfo, commune: e.target.value })}
    disabled={!orderInfo.wilaya}
  >
    <option value="">{langue === "fr" ? "Choisir une commune" : "اختر بلدية"}</option>
    {AlgeriaCities.filter((c) => c.wilaya_name_ascii === orderInfo.wilaya).map((commune, i) => (
      <option key={i} value={commune.commune_name_ascii}>
        {commune.commune_name_ascii}
      </option>
    ))}
  </select>
   <label className="block text-gray-900 text-lg   mb-1">
  {langue === "fr" ? "Mode de livraison" : "طريقة التوصيل"}
</label>
<select
  className="w-full bg-gray-200 text-gray-900 p-2 rounded-md"
  value={modeLivraison}
  onChange={(e) => setModeLivraison(e.target.value)}
>
  <option value="domicile">{langue === "fr" ? "À domicile" : "للمنزل"}</option>
 {orderInfo.commune == orderInfo.wilaya ? <option value="stopDesk">{langue === "fr" ? "Point relais" : "نقطة تسليم"}</option>:null}
</select>

{prixLivraison !== null && (
  <div className="mt-2 text-green-900 font-semibold">
    {langue === "fr"
      ? `Frais de livraison: ${prixLivraison} DA`
      : `سعر التوصيل: ${prixLivraison} دج`}
  </div>
)}

  {/* Bouton Confirmation */}
  <button
    onClick={() => handleConfirmOrder()}
    disabled={!orderInfo.nom || !orderInfo.telephone || !orderInfo.wilaya || !orderInfo.commune}
    className={`w-full font-bold py-3 rounded-lg text-white transition-all ${
      !orderInfo.nom || !orderInfo.telephone || !orderInfo.wilaya || !orderInfo.commune
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-green-700 hover:bg-green-800"
    }`}
  >
    {langue === "fr" ? "Confirmer la commande directe" : "تأكيد الطلب المباشر"}
  </button>
</div>

{/* Bouton Ajouter au panier */}
<button
  onClick={AjoutPanier}
  className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-lg flex justify-center items-center gap-2 shadow-md transition-transform transform hover:scale-105"
>
  {langue === "fr" ? "Ajouter au panier" : "أضف إلى السلة"}
  <ShoppingBasket className="size-5" />
</button>
      </div>
    </div>
  );
}

export default function WrappedPage() {
  return (
    <SnackbarProvider maxSnack={3}>
      <Page />
    </SnackbarProvider>
  );
}
